<template>
  <span :class="{ desktop: $isDesktop }" class="search-summary-listing">
    <translate
      v-if="distance && searchPlace"
      :tt="{ count, distance, searchPlace, bookableCount }"
      >{count} listing within {distance} of {searchPlace} with {bookableCount}
      bookable
    </translate>
    <translate
      v-else-if="distance && !searchPlace"
      :tt="{ count, distance, bookableCount }"
      >{count} listing within {distance} of your location with {bookableCount}
      bookable
    </translate>
    <translate
      v-else-if="hierarchyName"
      :tt="{ count, hierarchyName, bookableCount }"
      >{count} listing in {hierarchyName} with {bookableCount}
      bookable</translate
    >
    <translate v-else :tt="{ count, bookableCount }"
      >{count} listing with {bookableCount} bookable
    </translate>
  </span>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class SearchSummaryListing extends Vue {
  @Prop()
  count: number

  @Prop()
  bookableCount: number

  @Prop()
  distance: object

  @Prop()
  searchPlace: string

  @Prop()
  hierarchyName: string

  @Prop()
  categoryName: string

  @Prop()
  isUserLocationSearch: boolean
}

export default toNative(SearchSummaryListing)
</script>

<style scoped>
.search-summary-listing {
  overflow-wrap: break-word;
  max-width: 95vw;

  &.desktop {
    max-width: 100%;
  }
}
</style>
